module.exports = __webpack_public_path__ + "static/media/raval-trade.0d199050.jpg";